import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "ss_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    try { setItems(JSON.parse(localStorage.getItem(KEY)) || []); } catch {}
    setHydrated(true);
  }, []);
  useEffect(() => {
    if (!hydrated) return;
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items, hydrated]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const isGaming = product.kind === "gaming" || !!product.product_type;
      const kind = isGaming ? "gaming" : "shop";
      const key = (p) => p.product_id === product.id && (p.kind || "shop") === kind;
      const ex = prev.find(key);
      if (ex) return prev.map((p) => key(p) ? { ...p, quantity: p.quantity + qty } : p);
      return [...prev, {
        product_id: product.id,
        slug: product.slug,
        name: product.name,
        price: product.price,
        image: product.images?.[0],
        quantity: qty,
        kind,
        product_type: isGaming ? (product.product_type || "physical") : undefined,
        condition: isGaming ? product.condition : undefined,
      }];
    });
    setOpen(true);
  };
  const update = (pid, qty, kind = "shop") => {
    if (qty <= 0) return remove(pid, kind);
    setItems((prev) => prev.map((p) => (p.product_id === pid && (p.kind || "shop") === kind) ? { ...p, quantity: qty } : p));
  };
  const remove = (pid, kind = "shop") => setItems((prev) => prev.filter((p) => !(p.product_id === pid && (p.kind || "shop") === kind)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const hasPhysicalGaming = items.some((i) => i.kind === "gaming" && i.product_type === "physical");

  return (
    <CartCtx.Provider value={{ items, add, update, remove, clear, subtotal, count, hasPhysicalGaming, open, setOpen, hydrated }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
